import { getApiClient } from '../../api/client';
import type {
  VoiceTestCallCreateRequest,
  VoiceTestCallCreateResponse,
  VoiceTestCallRead,
} from '../types';

export type ListVoiceTestCallsParams = {
  report_id?: number;
  status?: string;
  limit?: number;
  offset?: number;
};

export async function createVoiceTestCall(
  reportId: number,
  body: VoiceTestCallCreateRequest,
): Promise<VoiceTestCallCreateResponse> {
  const client = getApiClient();
  const { data, error } = await client.POST('/voice-test-calls/scorecards/{report_id}/test-call', {
    params: { path: { report_id: reportId } },
    body,
  });
  if (error) throw new Error(`Failed to create internal voice test call: ${JSON.stringify(error)}`);
  if (!data) throw new Error('Failed to create internal voice test call: empty response');
  return data;
}

export async function listVoiceTestCalls(
  params: ListVoiceTestCallsParams = {},
): Promise<VoiceTestCallRead[]> {
  const client = getApiClient();
  const query = {
    limit: params.limit ?? 20,
    offset: params.offset ?? 0,
    ...(params.report_id ? { report_id: params.report_id } : {}),
    ...(params.status ? { status: params.status } : {}),
  };
  const { data, error } = await client.GET('/voice-test-calls/', {
    params: { query },
  });
  if (error) throw new Error(`Failed to fetch internal voice test calls: ${JSON.stringify(error)}`);
  return data ?? [];
}
